import Layout from '@/views/judge/layout/Layout.vue'
export default [
  {
    name: 'JudgeLayout',
    path: '/',
    component: Layout,
    redirect: { path: '/judge/trial-mgt' },
    children: [
      {
        name: 'JudgeTrialMgt',
        path: '/judge/trial-mgt',
        meta: { keepAlive: false },
        component: () => import(/* webpackChunkName: "TrialMgtJudge" */'@/views/judge/trialMgt/Home.vue')
      },
      {
        name: 'JudgeMy',
        path: '/judge/my',
        props: true,
        component: () => import(/* webpackChunkName: "judgeMy" */'@/views/judge/my/Home.vue')
      },
      {
        name: 'Welcome',
        path: '/welcome',
        props: true,
        component: () => import(/* webpackChunkName: "welcomeJudge" */'@/views/judge/Welcome.vue')
      }
    ]
  },
  {
    name: 'JudgeCaseDetail',
    path: '/judge/trial-mgt/:id',
    component: () => import(/* webpackChunkName: "CaseDetailJudge" */'@/views/judge/caseDetail/Home.vue')
  },
  {
    name: 'JudgeESign',
    path: '/judge/my/esign',
    props: true,
    component: () => import(/* webpackChunkName: "JudgeESign" */'@/views/judge/my/ESign.vue')
  },
  {
    name: 'JudgeAddESign',
    path: '/judge/my/add-esign',
    props: true,
    component: () => import(/* webpackChunkName: "JudgeAddESign" */'@/views/judge/my/AddESign.vue')
  },
  {
    path: '/judge/signature-document/:docId',
    name: 'SignatureOfDocument',
    props: { isJudge: 1 },
    component: () => import(/* webpackChunkName: "SignatureOfDocument" */ '@/views/signatureOfDoc/Home.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "notFound" */'@/views/error/404.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/permissionRoutes/judgeRoutes.js